/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class SafetyTrackingViewer {
    'viewer': SimpleUser;
    'isWatching'?: boolean;
    'dtAdded': Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "viewer",
            "baseName": "viewer",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "isWatching",
            "baseName": "isWatching",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "dtAdded",
            "baseName": "dtAdded",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return SafetyTrackingViewer.attributeTypeMap;
    }

    public constructor() {
    }
}

